import type { FocusAreaId, SafetyClass } from '../types';
import { focusAreaById } from '../focusAreas';

export type SafetyRoute =
  | { kind: 'standard'; note: string }
  | { kind: 'substance'; note: string; disclaimer: string }
  | { kind: 'crisis'; note: string; resources: string[] };

/**
 * Safety routing is independent of engagement ranking.
 * Substance pathways never get "streak" or commercial ranking logic.
 */
export const routeSafety = (focusAreaIds: FocusAreaId[]): SafetyRoute => {
  const classes = focusAreaIds
    .map((id) => focusAreaById(id)?.safetyClass)
    .filter(Boolean) as SafetyClass[];

  if (classes.includes('crisis_adjacent')) {
    return {
      kind: 'crisis',
      note: 'If you are in immediate danger, contact local emergency services.',
      resources: [
        'Emergency services in your country',
        'A trusted person who knows where you are',
      ],
    };
  }

  if (classes.includes('substance')) {
    return {
      kind: 'substance',
      note: 'Chems support here is harm-aware and user-led. It is not treatment.',
      disclaimer:
        'HOTTR.me is not a medical service, addiction treatment, or emergency care. AI coaching is not a substitute for professional help. A hard day does not erase your progress.',
    };
  }

  return {
    kind: 'standard',
    note: 'Behaviour change support — practical moves, no labels.',
  };
};

export const isSubstanceFocus = (focusAreaIds: FocusAreaId[]): boolean =>
  focusAreaIds.some((id) => focusAreaById(id)?.safetyClass === 'substance');
